import React from 'react';
import { RouteObject } from 'react-router-dom';
import AppLayout from './components/AppLayout/AppLayout';
import NotFound from './components/NotFound';
import DefaultRedirect from './components/DefaultRedirect';

const LoginPage = React.lazy(() => import('./components/Login/LoginPage'));
const RegisterPage = React.lazy(() => import('./components/Register/RegisterPage'));
const WeeklyViewPage = React.lazy(() => import('./components/WeeklyView/WeeklyViewPage'));
const UsersPage = React.lazy(() => import('./components/Users/UsersPage'));

export const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <DefaultRedirect /> },
      { path: 'weekly-view', element: <WeeklyViewPage /> },
      { path: 'users', element: <UsersPage /> },
    ],
  },
  { path: '*', element: <NotFound /> },
];
